import { QuoteState } from '../../../enums/quoteState'

export const quotesStateToTitleKey: Record<QuoteState, string> = {
  [QuoteState.All]: 'legacyQuotes.category.all',
  [QuoteState.Open]: 'legacyQuotes.category.open',
  [QuoteState.Closed]: 'legacyQuotes.category.closed',
}
